import React from 'react'
import ReactModal from 'react-modal'
import styles from './Modal.scss'
import { classNames } from './../../utils/styles'
import * as translationService from './../../services/translationService'
import PropTypes from 'prop-types'
import Icon from './../Icon'
import Button from './../Button'
import DisplayText from './../DisplayText'

ReactModal.setAppElement('#root')

export default function Modal({
  children,
  onRequestClose,
  title,
  isRequired = true,
  isCompact,
  hasDismiss = true,
  ...rest
}) {
  const classes = classNames(styles.ModalOverlay, isCompact && styles.Compact)
  return (
    <ReactModal
      shouldCloseOnOverlayClick={true}
      className={styles.Modal}
      onRequestClose={onRequestClose}
      overlayClassName={classes}
      {...rest}>
      {!isCompact && (
        <ModalHeader>
          <DisplayText size="small">
            {title}
            {!isRequired && <small> {translationService.t('system.optional')}</small>}
          </DisplayText>
          {hasDismiss && (
            <Button plain onClick={onRequestClose}>
              <Icon source="close" />
            </Button>
          )}
        </ModalHeader>
      )}
      {children}
    </ReactModal>
  )
}
Modal.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  isRequired: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  hasDismiss: PropTypes.bool,
}

const defaultPropTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
}

export function ModalHeader(props) {
  return <div className={classNames(styles.Header, props.className)}>{props.children}</div>
}
export function ModalBody({ children, className, ...rest }) {
  return (
    <div className={classNames(styles.Body, className)} {...rest}>
      {children}
    </div>
  )
}
export function ModalFooter(props) {
  return <div className={classNames(styles.Footer, props.className)}>{props.children}</div>
}

ModalHeader.propTypes = defaultPropTypes
ModalBody.propTypes = defaultPropTypes
ModalFooter.propTypes = defaultPropTypes



// WEBPACK FOOTER //
// ./src/components/Modal/index.js